import {
  Button,
  DropdownMenu
} from "@ifrc-go/ui"

import {
  getUserLanguage,
  languages,
  onChangeLanguage
} from "#utils/i18n"

import arFlag from "./arFlag.svg";
import enFlag from "./enFlag.svg";
import esFlag from "./esFlag.svg";
import frFlag from "./frFlag.svg";
import ptFlag from "./ptFlag.svg";
import ruFlag from "./ruFlag.svg";

import styles from "./styles.module.css";

const iconMapping = {
    ar: arFlag,
    en: enFlag,
    es: esFlag,
    fr: frFlag,
    pt: ptFlag,
    ru: ruFlag,
}

function LanguageSelect() {
  return (
    <DropdownMenu
      label={getUserLanguage().toUpperCase()}
      variant="tertiary"
    >
      {languages.filter((lang) => lang.value === 'en').map((language) => (
        <Button
          className={styles.languageSelectButton}
          name={undefined}
          key={`navbar-languages-${language.value}`}
          kind="ghost"
          icons={(
            <img
              className={styles.flag}
              alt="flag"
              src={iconMapping[language.value]}
            />
          )}
          onClick={() => onChangeLanguage(language)}
          variant="dropdown-item"
        >
          {language.label}
        </Button>
      ))}
    </DropdownMenu>
  );
}

export default LanguageSelect;
